
import GoTrue from 'gotrue-js'

import { isLocalHost } from 'helper/localhost'
import { APIUrl, isActive, audience } from 'config/auth'

/**
 * Config & Init
 */
let config = APIUrl ? { APIUrl } : {}
config = Object.assign(config, { 
  audience
});
let auth = new GoTrue(config)

/**
 * Log in / out
 */
export const login = ({ email, password }) => {
  sessionStorage.setItem('last_user_email', email)
  
  return auth.login(email, password, true)
}
export const logout = () => {
  let user = getUser()
  if (user) {
    user.logout()
  }
}
/**
 * Login Status
 */
export const isLoggedIn = () => {
  return !! getUser() || 
    ! isActive || 
    // without an APIUrl login won't work on localhost
    (!APIUrl && isLocalHost)
}

/**
 * Register / confirm / recover
 */
export const register = ({ email, password, data }) => {
  return auth.signup(email, password, data)
}
export const confirm = ({ token }) => {
  return auth.confirm(token, true)
}
export const requestPasswordRecovery = ({ email }) => {
  return auth.requestPasswordRecovery(email)
}
export const recoverAccount = ({ token }) => {
  return auth.recover(token, true)
}
export const acceptInvite = ({ token, password }) => {
  return auth.acceptInvite(token, password, true)
}

/**
 * Update
 */
export const update = (data) => {
  let user = getUser()
  if (user) {
    return user.update(data)
  }
  return Promise.reject('User not logged in')
}

/**
 * Role
 */
export const getRoles = () => {
  let user = getUser()
  return (user) ? user.app_metadata.roles : []
}
export const isAdmin = () => {
  return getRoles().includes('beheerder')
}
export const isPlanModeAdmin = () => {
  return getRoles().includes('beheerder') || getRoles().includes('gemeente-beheerder')
}
export const isAnalist = () => {
  return getRoles().includes('gemeente-gebruiker') || getRoles().includes('beheerder') || getRoles().includes('gemeente-beheerder')
}
export const isEntrepreneur = () => {
  return getRoles().includes('eindgebruiker')
}

/**
 * Helper
 */
export const getLastUserEmail = () => {
  return sessionStorage.getItem('last_user_email') || ''
}

/**
 * Obtain User object
 */
export const getUser = () => {
  // eslint-disable-next-line
  return auth.currentUser()
}

/**
 * JWT for API calls
 */
export const getJWT = async () => {
  let user = getUser()
  
  return await user.jwt()
    .then(response => response)
    .catch(() => {
      return null
    })
}
